// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1TyXq","btn":"styles_btn__1n9AA","tags":"styles_tags__3Q1_9"};